import React, { useContext } from 'react';

import {
  HeaderWrapper,
  HeaderContainer,
  HeaderChildren,
  HeaderLogo,
} from '@imgly/imgly-website-components';
import classNames from 'classnames';

import { PageLayout } from '../../../types';
import { PageContext } from '../../context/PageContext';

import { HeaderMenuButton } from './HeaderMenuButton';
import { HeaderSearch } from './HeaderSearch';
import * as classes from './style.module.scss';

export const Header: React.FC = () => {
  const { platforms, layout } = useContext(PageContext);

  return (
    <header className={classes.root}>
      <HeaderWrapper className={classes.wrapper}>
        <HeaderMenuButton
          className={classNames({
            [classes.basic]: layout === PageLayout.Basic,
          })}
        />
        <div className={classes.logoContainer}>
          <HeaderLogo className={classes.logo} />
          <span className={classes.text}>Documentation</span>
        </div>
        <HeaderSearch
          className={classNames({
            [classes.basic]: layout === PageLayout.Basic,
          })}
        />
        <HeaderContainer>
          <HeaderChildren small />
        </HeaderContainer>
      </HeaderWrapper>
    </header>
  );
};
